var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BottomAppBar",
    [
      _vm.actionType === "manage"
        ? [
            _c(
              "KButtonGroup",
              [
                _c("span", { staticClass: "message" }, [
                  _vm._v(_vm._s(_vm.selectedMessage)),
                ]),
                _c("KButton", {
                  attrs: {
                    disabled: _vm.$attrs.disabled || _vm.buttonsDisabled,
                    text: _vm.coreString("deleteAction"),
                    primary: false,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("selectoption", "DELETE")
                    },
                  },
                }),
                _c("KButton", {
                  attrs: {
                    disabled: _vm.$attrs.disabled || _vm.buttonsDisabled,
                    text: _vm.$tr("exportAction"),
                    primary: true,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("selectoption", "EXPORT")
                    },
                  },
                }),
              ],
              1
            ),
          ]
        : [
            _c("span", { staticClass: "message" }, [
              _vm._v(_vm._s(_vm.selectedMessage)),
            ]),
            _c("KButton", {
              attrs: {
                disabled: _vm.$attrs.disabled || _vm.buttonsDisabled,
                text: _vm.confirmButtonLabel,
                primary: true,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("clickconfirm")
                },
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }